module.exports = __webpack_public_path__ + "static/media/how_to_2.eca9f133.svg";